export function getUrl(route) {
	return `${window.location.origin}/${route}`;
}
